import {
    SetPositionsMessagePayload,
    setPositionsMessagePayloadSchema,
} from 'embedded/api/in/messages/SetPositionsMessagePayload';
import { InMessageTopic } from 'embedded/api/in/InMessageTopic';
import { Store } from 'redux';
import { LoggingService } from '@instinet-analytics/core-lib';
import { PortfolioPosition } from 'portfolio/PortfolioSelection';
import { SymbologyValues } from 'app/store/appSettings/AppSettingsState';
import { embeddedAppStateActions } from 'embedded/store/embeddedAppStateSlice';

export class SetPositionsMessage extends InMessageTopic<SetPositionsMessagePayload> {
    public constructor() {
        super(setPositionsMessagePayloadSchema);
    }

    public handle(
        uid: string,
        payload: SetPositionsMessagePayload,
        store: Store,
        _loggingService: LoggingService
    ): void {
        const symbology: SymbologyValues =
            payload.symbology ?? SymbologyValues.Instinet;

        const positions: PortfolioPosition[] = payload.positions.map((p) => {
            const { symbol, qty: payloadQty, side: payloadSide } = p;
            const qty = payloadQty === undefined ? 1 : payloadQty;
            const absQty = Math.abs(qty);
            const side = payloadSide ? payloadSide : qty >= 0 ? 'B' : 'S';

            return {
                symbol,
                qty: absQty,
                side,
                qtyRemaining: absQty,
            };
        });
        store.dispatch(
            embeddedAppStateActions.setPositions({
                values: positions,
                symbology,
            })
        );
    }
}
